<template>
  <el-form :model="form" :rules="rules" ref="form">
  <div class="d-flex flex-wrap justify-content-between align-items-center flex-gap-16">
      <span>Шаг {{step.ordinalNumber}}. {{step.stepName}}</span>
      <div class="d-flex flex-wrap justify-content-end flex-gap-10">
        <el-form-item v-if="isEdited" prop="files">
          <el-upload ref="upload" action="/" multiple
                     :show-file-list="false" :auto-upload="false"
                     :on-change="onChangeFiles">
            <el-button slot="trigger" icon="el-icon-plus" size="medium">
              Прикрепить файл
            </el-button>
          </el-upload>
        </el-form-item>
        <div v-if="$isAccess($userRoles.Admin, $userRoles.Dispatcher)">
          <el-button v-if="isEdited" type="primary" size="medium" :loading="updateProgress || uploadFileCount>0" @click="onSave">
            Сохранить
          </el-button>
          <el-button v-else size="medium" @click="isEdited=true" :loading="updateProgress">
            Изменить
          </el-button>
        </div>
      </div>
    </div>

    <FilesBlock class="mt-4" v-if="form.files.length" :files="form.files" :isEdited="isEdited" @onRemove="onRemoveFile" />
    <el-alert v-else class="mt-3" title="Прикрепленные файлы отсутствуют" type="warning" :closable="false" />
  </el-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FilesBlock from '@/components/ui/FilesBlock';

export default {
  components: {
    FilesBlock,
  },
  props: {
    step: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isEdited: false,
    uploadFileCount: 0,
    form: {
      files: [],
      state: null,
    },
    rules: {},
  }),
  computed: {
    ...mapGetters({
      item: 'orders/item',
      updateProgress: 'orders/updateProgress',
    }),
  },
  methods: {
    ...mapActions({
      uploadFileGetUrl: 'files/uploadFileGetUrl',
      updateStep: 'orders/updateStep',
    }),
    fillForm() {
      this.form.files = this.step.files.map((file) => ({
        fileName: file.fileName,
        id: file.fileId,
        url: file.fileUrl,
        contentType: file.fileContentType,
      }));

      this.form.state = this.step.stepState;
    },
    onChangeFiles(evt) {
      this.uploadFileCount += 1;
      this.uploadFileGetUrl({ file: evt.raw })
        .then((file) => {
          this.form.files.push(file);
        })
        .finally(() => {
          this.uploadFileCount -= 1;
        });
    },
    onRemoveFile(file) {
      const fileIndex = this.form.files.findIndex((f) => f.id === file.id);
      if (fileIndex > -1) {
        this.form.files.splice(fileIndex, 1);
      }
    },
    onSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { visitOrderId: id } = this.item;
          const stepNumber = this.step.ordinalNumber;

          const data = {
            ...this.form,
          };
          this.updateStep({ id, stepNumber, data })
            .then(() => {
              this.isEdited = false;
            });
        }
      });
    },
  },
  created() {
    this.fillForm();
  },
};
</script>
